<template>
	<div>
		<section class="breadcrumbs">
		  <div class="container">
		    <ol>
		      <li><router-link to="/"><a href="">首页</a></router-link></li>
		      <li>联系我们</li>
		    </ol>
		    <h2>联系我们</h2>
		  </div>
		</section>
		
		<!-- ======= 联系我们 ======= -->
		<section id="contact" class="contact">
		  <div class="container" data-aos="fade-up">
		    <div class="row gy-4">
		      <div class="col-lg-6">
		        <div class="row gy-4">
		          <div class="col-md-6">
		            <div class="info-box">
		              <i class="bi bi-geo-alt"></i>
		              <h3>地址</h3>
		              <p>{{contact.address}}</p>
		            </div>
		          </div>
		          <div class="col-md-6">
		            <div class="info-box">
		              <i class="bi bi-telephone"></i>
		              <h3>电话</h3>
		              <p>{{contact.phone1}}<br>{{contact.phone2}}</p>
		            </div>
		          </div>
				  
				  <div class="col-lg-6">
				    <form action="forms/contact.php" method="post" class="php-email-form">
				      <div class="row gy-4">
							<h4>公众号</h4>
							<img :src="$global.baseURL + contact.weixinPic"/>
				      </div>
				    </form>
				  </div>
				  
		        </div>
		      </div>
			   <div class="col-lg-6">
			       <div class="row gy-4">
						<MapContainer></MapContainer>
			       </div>
			   </div>
		    </div>
		  </div>
		</section>
		
	</div>
	
</template>

<script>
	import axios from 'axios'
	import {mapState} from 'vuex'
	import MapContainer from './mapContainer.vue'

	export default{
		name: 'EndFooter',
		components:{
			MapContainer
		},
		computed:{
			...mapState({
				contact: state => state.contact
			})
		},
		mounted() {
			console.log(this.contact);
		}
	}
</script>

<style>
</style>